import {
  ADD_NOTIFICATION, HOVER, REMOVE_NOTIFICATION,
  START_NOTIFICATION_TRANSITION, UNHOVER
} from "./notifications-action-types";
import deepCopy from "../../utilities/deepCopy";


const initialState = {
  notifications: []
};


export default ( state = initialState, action ) => {
  const { message, status, id } = action;

  let index;
  const notifications = deepCopy(state.notifications);
  switch(action.type) {

    case UNHOVER:
      index = notifications.findIndex(n => n.id === id);
      notifications[index].hovered = false;
      return {
        ...state,
        notifications
      };

    case HOVER:
      index = notifications.findIndex(n => n.id === id);
      notifications[index].hovered = true;
      return {
        ...state,
        notifications
      };

    case REMOVE_NOTIFICATION:
      index = notifications.findIndex(n => n.id === id);
      notifications.splice(index, 1);
      return {
        ...state,
        notifications
      };

    case START_NOTIFICATION_TRANSITION:
      index = notifications.findIndex(n => n.id === id);
      notifications[index] = {...notifications[index], transition: !notifications[index].transition };

      return {
        ...state,
        notifications
      };

    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            message,
            status,
            id,
            transition: false,
            hovered: false
          }
        ]
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/notifications/notifications-reducer.js